import { ChevronLeft, ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'

interface RailArrowProps {
  direction: 'prev' | 'next'
  disabled: boolean
  onClick: () => void
  /** Id do trilho que a seta controla — vira `aria-controls`. */
  controls: string
  /** Entra no rótulo: "Ver mais fotógrafos". */
  noun: string
  className?: string
}

/**
 * A seta de um trilho horizontal.
 *
 * Vem do Figma (nós 93:442 ativo e 93:439 desabilitado): círculo de 32px, ícone
 * de 16, e a diferença entre os dois estados é só o tom do cinza. Os hexes são
 * os do desenho — são neutros, não competem com a cor da marca, e aproximar
 * para a escala de cinza do Tailwind mudaria o desenho sem ganhar nada.
 *
 * Componente próprio porque a mesma seta serve os dois trilhos do /explore: a
 * fila de serviços do header e os carrosséis das seções da vista lista. Duas
 * cópias divergiriam no primeiro ajuste de tamanho.
 *
 * Fica DESABILITADA em vez de sumir, ao contrário do que estava aqui antes: o
 * desenho tem um estado para isso, e uma seta que aparece e some faz a linha de
 * controles pular de largura a cada rolagem.
 */
export default function RailArrow({
  direction,
  disabled,
  onClick,
  controls,
  noun,
  className,
}: RailArrowProps) {
  const Icon = direction === 'prev' ? ChevronLeft : ChevronRight

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-controls={controls}
      aria-label={
        direction === 'prev' ? `Ver ${noun} anteriores` : `Ver mais ${noun}`
      }
      className={cn(
        'inline-flex size-8 shrink-0 items-center justify-center rounded-full transition-colors',
        disabled
          ? 'cursor-default bg-[#e9ecef] text-gray-400'
          : 'bg-[#ced4da] text-gray-700 hover:bg-gray-400 hover:text-white',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
        className,
      )}
    >
      <Icon className="size-4" aria-hidden="true" />
    </button>
  )
}
